// InvoiceDocument2.js
import React, { useEffect, useState } from "react";
import { Page, Text, View, Document, StyleSheet, PDFViewer, PDFDownloadLink, Image, Font } from '@react-pdf/renderer';
import apiService from "../../Services/apiServices";
import globals from '../../Services/globals';
import { auto, right } from '@popperjs/core';
import calculate from '../../Services/calculate';
import helper from '../../Services/helper';
import LoaderComponent from '../UI/Components/LoaderComponent';
import config from '../../config/config';
import FontUbuntuRegular from './fonts/Ubuntu-Regular.ttf';
import FontUbuntuItalic from './fonts/Ubuntu-Italic.ttf';
import FontUbuntu700 from './fonts/Ubuntu-Bold.ttf';
import FontUbuntuLight from './fonts/Ubuntu-Light.ttf';

const InvoiceDocument2 = ({ saleObj }) => {
    //const [saleId, setSaleId] = useState(saleId);
    const [sale, setSale] = useState(saleObj);
    const [saleDetails, setSaleDetails] = useState(saleObj.salesDetails || []);
    const [partner, setPartner] = useState(saleObj.partner || {});
    const [saleType, setSaleType] = useState({});
    const [units, setUnits] = useState(saleObj.units);
    const [settings, setSettings] = useState(saleObj.settings);
    const [vatGroup, setVatGroup] = useState(saleObj.vatGroup);
    const [loader, setLoader] = useState(true);
    const [calTotalWithoutDiscount, setCalTotalWithoutDiscount] = useState(0);
    const [isDiscount, setIsDiscount] = useState(false);
    const [isDiscount2, setIsDiscount2] = useState(false);
    const [isDiscount3, setIsDiscount3] = useState(false);
    const [isDiscount4, setIsDiscount4] = useState(false);
    const [isVat, setIsVat] = useState(false);
    const [digitalStamp, setDigitalStamp] = useState(true) //useState(props?.match?.params?.type === 'ds' ? true : false);
    const [isBarcode, setIsBarcode] = useState(true);
    const [isExport, setIsExport] = useState(saleObj.isExport);

    useEffect(() => {
        console.log(saleObj)

        var totalWithoutDiscount = 0;
        let data = saleObj.salesDetails;
        for (var i = 0; i < data.length; i++) {
            parseFloat(data[i].vat) > 0 && setIsVat(true);
            parseFloat(data[i].discount) > 0 && setIsDiscount(true);
            parseFloat(data[i].discount2) > 0 && setIsDiscount2(true);
            parseFloat(data[i].discount3) > 0 && setIsDiscount3(true);
            parseFloat(data[i].discount4) > 0 && setIsDiscount4(true);

            var addedTotalWithoutDiscount = parseFloat(data[i].quantity) * parseFloat(data[i].price);
            totalWithoutDiscount += addedTotalWithoutDiscount;

            if (data[i].discount > 0 || data[i].discount2 > 0 || data[i].discount3 > 0 || data[i].discount4 > 0) {
                data[i].priceDiscount = calculate().calculateSale('priceMultipleDiscount')(
                    data[i].price,
                    data[i].discount,
                    data[i].discount2,
                    data[i].discount3,
                    data[i].discount4
                );
                data[i].priceTvsh = calculate().calculateSale("priceTvsh")(data[i].priceDiscount, data[i].vat);
                data[i].totalPrice = calculate().calculateSale("totalPrice")(data[i].priceDiscount, data[i].quantity);
                data[i].totalPriceTvsh = calculate().calculateSale("totalPriceTvsh")(data[i].totalPrice, data[i].vat);
            } else {
                data[i].priceTvsh = calculate().calculateSale("priceTvsh")(data[i].price, data[i].vat);
                data[i].totalPrice = calculate().calculateSale("totalPrice")(data[i].price, data[i].quantity);
                data[i].totalPriceTvsh = calculate().calculateSale("totalPriceTvsh")(data[i].totalPrice, data[i].vat);
            }
        }

        grupByVat(data);
        setSaleDetails(data);
        setCalTotalWithoutDiscount(totalWithoutDiscount)
        setLoader(false);
    }, []);

    const grupByVat = (items) => {
        let group = items.reduce((r, a) => {
            r[a.vat] = [...(r[a.vat] || []), a];
            return r;
        }, {});
        vatGroupFunc(group);
    };

    const getSaleDetails = (saleId, partnerId, salesTypeId) => {
        apiService()
            .query("getSaleDetails", "saleId=" + saleId)
            .then((response) => {
                var data = response.data;
                if (response.success) {
                    var totalWithoutDiscount = 0;
                    for (var i = 0; i < data.length; i++) {
                        parseFloat(data[i].vat) > 0 && setIsVat(true)
                        parseFloat(data[i].discount) > 0 && setIsDiscount(true)
                        parseFloat(data[i].discount2) > 0 && setIsDiscount2(true)
                        parseFloat(data[i].discount3) > 0 && setIsDiscount3(true)
                        parseFloat(data[i].discount4) > 0 && setIsDiscount4(true)
                        var addedTotalWithoutDiscount = parseFloat(data[i].quantity) * parseFloat(data[i].price);
                        totalWithoutDiscount = totalWithoutDiscount + addedTotalWithoutDiscount;
                        if (data[i].discount > 0 || data[i].discount2 > 0 || data[i].discount3 > 0 || data[i].discount4 > 0) {
                            data[i].priceDiscount = calculate().calculateSale('priceMultipleDiscount')(data[i].price, data[i].discount, data[i].discount2, data[i].discount3, data[i].discount4);
                            data[i].priceTvsh = calculate().calculateSale("priceTvsh")(
                                data[i].priceDiscount,
                                data[i].vat
                            );
                            data[i].totalPrice = calculate().calculateSale("totalPrice")(
                                data[i].priceDiscount,
                                data[i].quantity
                            );
                            data[i].totalPriceTvsh = calculate().calculateSale(
                                "totalPriceTvsh"
                            )(data[i].totalPrice, data[i].vat);
                            // data[i].totalPriceItemTvsh= calculate().calculateSale('totalPriceItemTvsh')(data[i].totalPriceTvsh , data[i].quantity);
                        } else {
                            data[i].priceTvsh = calculate().calculateSale("priceTvsh")(
                                data[i].price,
                                data[i].vat
                            );
                            data[i].totalPrice = calculate().calculateSale("totalPrice")(
                                data[i].price,
                                data[i].quantity
                            );
                            data[i].totalPriceTvsh = calculate().calculateSale(
                                "totalPriceTvsh"
                            )(data[i].totalPrice, data[i].vat);
                            // data[i].totalPriceItemTvsh= calculate().calculateSale('totalPriceItemTvsh')(data[i].totalPriceTvsh , data[i].quantity);
                        }
                    }
                    grupByVat(data);
                    setSaleDetails(data);
                    setCalTotalWithoutDiscount(totalWithoutDiscount)
                    setLoader(false);
                } else {
                    console.log("ka gabim sd: ", response);
                    //props.addToast('Ka ndodhur nje gabim!', { appearance: 'error', autoDismiss: true, });
                }
            });
        apiService()
            .query("partner", "id=" + partnerId)
            .then((response) => {
                if (response.success) {
                    setPartner(response.data[0]);
                    //console.log('Partner: ', response.data);
                } else {
                    console.log("Error:" + response.errorMessage);
                }
            });
        apiService()
            .query("getSaleType", "id=" + salesTypeId)
            .then((response) => {
                if (response.success) {
                    setSaleType(response.data[0]);
                } else {
                    console.log("Error:" + response.errorMessage);
                }
            });
    };

    const checkColumn = (property, items) => {
        // const isTrue = (currentValue) => currentValue[property];
        // return items?.every(isTrue)
        return true;
    };

    const vatGroupFunc = (group) => {
        let arr = [];
        Object.entries(group).forEach(([key, value]) => {
            arr.push({ key: key, value: calculateVat(value) });
        });
        setVatGroup(arr);
    };
    const calculateVat = (items) => {
        return items?.reduce(
            (accumulator, current) => parseFloat(accumulator) + current.vatSum,
            0
        );
    };

    Font.register({
        family: 'Ubuntu',
        fonts: [
            {
                src: FontUbuntuRegular,
            },
            {
                src: FontUbuntuItalic,
                fontWeight: 'italic',
            },
            {
                src: FontUbuntu700,
                fontWeight: 'bold',
            },
            {
                src: FontUbuntuLight,
                fontWeight: 'light',
            },
        ],
    });
    let styles = StyleSheet.create({
        page: {
            display: 'flex',
            //flexDirection: 'row',
            //alignItems:'baseline',
            backgroundColor: '#fff',
            width: '100%',
            flexDirection: 'row'
        },
        italicFont: {
            fontFamily: "Times-Italic"
        },
        section: {
            //paddingHorizontal: 5,
            flexGrow: 1,
            width: '50%',
        },
        td: {
            marginLeft: 10,
            marginRight: 10
        },
        text: {
            // borderBottom: 1, 
            fontSize: 9,
            paddingTop: 2,
            paddingHorizontal: 2
        },
        textTblHeader: {
            paddingVertical: 2, fontFamily: 'Ubuntu', fontSize: 10, fontWeight: 'bold'
        },
        textTotal: {
            paddingVertical: 3, fontFamily: 'Ubuntu', fontSize: 10, fontWeight: 'bold'
        },
        text10: {
            paddingVertical: 2, fontFamily: 'Ubuntu', fontSize: 10, fontWeight: 'light'
        },
        pageNumbers: {
            position: 'absolute',
            bottom: 10,
            left: 0,
            right: 0,
            textAlign: 'center',
            fontSize: 6,
            // top: '15%'
            marginLeft: 5,
            marginRight: 5,
            marginTop: 10,
            marginBottom: -5
        },
    });

    return (
        <Document >
            <Page size="A4" style={{ paddingVertical: 10, paddingHorizontal: 15, marginTop: 5 }} wrap>
                <View style={styles.page}>
                    <View style={styles.section}>
                        <Text style={[styles.text10, { fontSize: 11, fontWeight: 'bold' }]}>{settings.companyName}</Text>
                        <View style={styles.page}>
                            <View style={styles.section}>
                                {settings.businessNumber?.length > 2 && <Text style={styles.text10}>{helper().translate("NUI")}: {settings.businessNumber}</Text>}
                                {settings.fiscalNumber?.length > 2 && <Text style={styles.text10}>{helper().translate("FISCAL_NUMBER")}: {settings.fiscalNumber}</Text>}
                                {settings.vatNumber?.length > 2 && <Text style={styles.text10}>{helper().translate("VAT_NUMBER")}: {settings.vatNumber}</Text>}
                                {settings.accNo?.length > 2 && <Text style={styles.text10}>{helper().translate("BANK_NUMBER")}: {settings.accNo}</Text>}
                            </View>
                            <View style={styles.section}>
                                {sale.unitNo?.length > 2 && <Text style={styles.text}>{helper().translate("UNIT_NUMBER")}: {sale.unitNo}</Text>}
                                {sale.warehouseAddress?.length > 2 && <Text style={styles.text}>{helper().translate("ADDRESS")}: {sale.warehouseAddress}</Text>}
                                {sale.email?.length > 2 && <Text style={[styles.text]}>{helper().translate("EMAIL")}: {sale.email}</Text>}
                                {settings.phoneNo?.length > 2 && <Text style={styles.text}>Tel: {settings.phoneNo}</Text>}
                                {sale.branchPhone?.length > 2 && <Text style={[styles.text]}>{helper().translate("BRANCHE_PHONE_NUMBER")}: {sale.branchPhone}</Text>}
                            </View>
                        </View>
                        <Text style={[styles.italicFont, { fontSize: 9, fontWeight: 'bold', fontStyle: 'italic', marginTop: 10 }]}>{settings.announcement}</Text>
                    </View>
                    <View style={[styles.section, { display: "flex", alignItems: "center", justifyContent: "center" }]}>
                        <Image src={settings?.img ? settings?.img : config.noLogo} style={{ width: settings?.img ? '120px' : '120px' }} />
                    </View>
                </View>
                <hr style={{ height: 12 }}></hr>
                <View style={[styles.page, { borderTop: 1, marginTop: 2, paddingVertical: 5, alignItems: "flex-end" }]}>
                    <View style={[styles.section, { width: '60%', padding: 0 }]}>
                        <Text style={[styles.text10, { fontSize: 11, fontWeight: 'bold', width: '100%' }]}>{helper().translate("BUYER")}: {partner.partnerType !== 6 ? partner.companyName : partner.subjectName}</Text>
                        {partner?.partnerType === 6 && <Text style={[styles.text, { fontSize: 12, fontWeight: 'bold', width: '100%' }]}>{helper().translate("UNIT")}: {partner?.companyName}</Text>}
                        <View style={[styles.page, { width: '100%' }]}>
                            <View style={styles.section}>
                                {partner.businessNo?.length > 2 && <Text style={styles.text10}>{helper().translate("NUI")}: {partner.businessNo}</Text>}
                                {partner.fiscalNo?.length > 2 && <Text style={styles.text10}>{helper().translate("FISCAL_NUMBER")}: {partner.fiscalNo}</Text>}
                                {partner.vatNo?.length > 2 && <Text style={styles.text10}>{helper().translate("VAT_NUMBER")}: {partner.vatNo}</Text>}
                            </View>
                            <View style={[styles.section, { borderLeft: 1, paddingLeft: 5 }]}>
                                {partner.address?.length > 2 && <Text style={styles.text10}>{helper().translate("ADDRESS")}: {partner.address}</Text>}
                                {partner.city?.length > 2 && <Text style={styles.text10}>{helper().translate("CITY")}: {partner.city}</Text>}
                                {partner.phone?.length > 2 && <Text style={styles.text10}>{helper().translate("PHONE")}: {partner.phone}</Text>}
                            </View>
                        </View>
                        <Text style={{ border: 1, fontSize: 10, padding: 2, width: '50%', marginTop: 5 }}>{helper().translate("DATE")}: {helper().formatDate(sale.date)}</Text>
                    </View>
                    <View style={[styles.section, { width: '40%', paddingVertical: 5, paddingHorizontal: 20 }]}>
                        <Text style={{ fontSize: 18, fontWeight: 'bold', textAlign: 'center', backgroundColor: 'gray', paddingVertical: 3, color: '#fff' }}>{sale.salesTypeId == 1 ? helper().translate("SALE_INVOICE") : (sale.salesTypeId == 2) ? helper().translate(saleType.Type) : helper().translate(saleType.Type)}</Text>
                        <Text style={{ fontSize: 18, fontWeight: 'bold', textAlign: 'center', height: 30 }}></Text>
                        <Text style={{ fontSize: 18, fontWeight: 'bold', textAlign: 'center', borderBottom: '1px dotted #000' }}>{sale.invoiceNo}</Text>
                    </View>
                </View>
                <View style={{ border: 1, marginVertical: 0 }}>
                    {/* width 565px */}
                    <View style={[styles.page, { borderBottom: 1, paddingHorizontal: 0, minHeight: '12px', backgroundColor: "#F1F1F1" }]}>
                        <Text style={[styles.text10, { width: '20px', textAlign: 'center', borderRight: 0.5 }]}>{helper().translate("NR")}</Text>
                        {sale.isDraft && <Text style={[styles.text10, { width: '60px', textAlign: 'center', borderRight: 0.5, flexGrow: 3 }]}>{helper().translate("DATE")}</Text>}
                        {!sale.isDraft && isBarcode && <Text style={[styles.text10, { width: '80px', textAlign: 'center', borderRight: 0.5 }]}>{helper().translate("BARCODE")}</Text>}
                        <Text style={[styles.text10, { width: '125px', textAlign: 'center', borderRight: 0.5, flexGrow: 3 }]}>{helper().translate("DESIGNATION")}</Text>
                        {sale.isDraft && <Text style={[styles.text10, { width: '130px', textAlign: 'center', borderRight: 0.5, flexGrow: 3 }]}>{helper().translate("COMMENT")}</Text>}
                        <Text style={[styles.text10, { width: '35px', textAlign: 'center', borderRight: 0.5 }]}>{helper().translate("UNIT")}</Text>
                        {checkColumn('quantity', saleDetails) &&
                            <Text style={[styles.text10, { width: '35px', textAlign: 'center', borderRight: 0.5 }]}>{helper().translate("QUANTITY")}</Text>
                        }
                        {checkColumn('price', saleDetails) &&
                            <Text style={[styles.text10, { width: '55px', textAlign: 'center', borderRight: 0.5 }]}>{helper().translate("PRICE")}</Text>
                        }
                        {checkColumn('priceTvsh', saleDetails) && settings.withVat === true && isExport && isVat &&
                            <Text style={[styles.text10, { width: '55px', textAlign: 'center', borderRight: 0.5 }]}>{helper().translate("PRICE_WITH_VAT")}</Text>
                        }
                        {checkColumn('discount', saleDetails) && isDiscount &&
                            <Text style={[styles.text10, { width: '30px', textAlign: 'center', borderRight: 0.5 }]}>{helper().translate("DISCOUNT")} </Text>
                        }
                        {checkColumn('discount2', saleDetails) && isDiscount2 &&
                            <Text style={[styles.text10, { width: '30px', textAlign: 'center', borderRight: 0.5 }]}>{helper().translate("DISCOUNT_SHORT")}2 </Text>
                        }
                        {checkColumn('discount3', saleDetails) && isDiscount3 &&
                            <Text style={[styles.text10, { width: '30px', textAlign: 'center', borderRight: 0.5 }]}>{helper().translate("DISCOUNT_SHORT")}3 </Text>
                        }
                        {checkColumn('discount4', saleDetails) && isDiscount4 &&
                            <Text style={[styles.text10, { width: '30px', textAlign: 'center', borderRight: 0.5 }]}>{helper().translate("DISCOUNT_SHORT")}4 </Text>
                        }
                        {checkColumn('priceDiscount', saleDetails) && isDiscount && isDiscount2 && isDiscount3 && isDiscount4 &&
                            <Text style={[styles.text10, { width: '55px', textAlign: 'center', borderRight: 0.5 }]}>{helper().translate("PRICE_WITH_DISCOUNT")} </Text>
                        }
                        {checkColumn('vat', saleDetails) && settings.withVat === true && isExport && isVat &&
                            <Text style={[styles.text10, { width: '30px', textAlign: 'center', borderRight: 0.5 }]}>{helper().translate("VAT")} %</Text>
                        }
                        {checkColumn('vatSum', saleDetails) && settings.withVat === true && isExport && isVat &&
                            <Text style={[styles.text10, { width: '45px', textAlign: 'center', borderRight: 0.5 }]}>{helper().translate("VAT_VALUE")}</Text>
                        }
                        {checkColumn('totalPriceTvsh', saleDetails) &&
                            <Text style={[styles.text10, { width: '55px', textAlign: 'center' }]}>{settings.withVat === true && isExport && isVat ? helper().translate("TOTAL_WITH_VAT") : helper().translate("TOTAL")}</Text>
                        }
                    </View>
                    {saleDetails?.map((item, index) => (
                        <View wrap={false} key={index} style={[styles.page, { borderTop: 1, paddingHorizontal: 0, overflow: 'hidden', height: 'auto', backgroundColor: 'transparent' }]}>
                            <Text style={[styles.text10, { width: '20px', textAlign: 'center', borderRight: 0.5 }]}>{item.no}</Text>
                            {sale.isDraft && <Text style={[styles.text10, { width: '60px', textAlign: 'center', borderRight: 0.5, flexGrow: 2 }]}>{helper().formatDate(item.date)}</Text>}
                            {!sale.isDraft && isBarcode && <Text style={[styles.text10, { width: '80px', textAlign: 'center', borderRight: 0.5 }]}>{item.barcode}</Text>}
                            <Text style={[styles.text10, { width: '125px', textAlign: 'center', borderRight: 0.5, flexGrow: 2 }]}>{item.itemName}</Text>
                            {sale.isDraft && <Text style={[styles.text10, { width: '130px', textAlign: 'center', borderRight: 0.5, flexGrow: 2 }]}>{item.comment}</Text>}
                            <Text style={[styles.text10, { width: '35px', textAlign: 'center', borderRight: 0.5 }]}>{(units?.find(u => u.typeId === item.unitId))?.name}</Text>
                            {checkColumn('quantity', saleDetails) &&
                                <Text style={[styles.text10, { width: '35px', textAlign: 'center', borderRight: 0.5 }]}>{item.quantity}</Text>
                            }
                            {checkColumn('price', saleDetails) &&
                                <Text style={[styles.text10, { width: '55px', textAlign: 'center', borderRight: 0.5 }]}>{typeof (item.price) == 'undefined' ?
                                    item.price : helper().formatCurrency(item.price, true)}</Text>
                            }
                            {checkColumn('priceTvsh', saleDetails) && settings.withVat === true && isExport && isVat &&
                                <Text style={[styles.text10, { width: '55px', textAlign: 'center', borderRight: 0.5 }]}>{typeof (item.priceTvsh) == 'undefined' ?
                                    item.priceTvsh : helper().formatCurrency(item.priceTvsh, true)}</Text>
                            }
                            {checkColumn('discount', saleDetails) && isDiscount &&
                                <Text style={[styles.text10, { width: '30px', textAlign: 'center', borderRight: 0.5 }]}>{item.discount + "%"}</Text>
                            }
                            {checkColumn('discount2', saleDetails) && isDiscount2 &&
                                <Text style={[styles.text10, { width: '30px', textAlign: 'center', borderRight: 0.5 }]}>{item.discount2 + "%"}</Text>
                            }
                            {checkColumn('discount3', saleDetails) && isDiscount3 &&
                                <Text style={[styles.text10, { width: '30px', textAlign: 'center', borderRight: 0.5 }]}>{item.discount3 + "%"}</Text>
                            }
                            {checkColumn('discount4', saleDetails) && isDiscount4 &&
                                <Text style={[styles.text10, { width: '30px', textAlign: 'center', borderRight: 0.5 }]}>{item.discount4 + "%"}</Text>
                            }
                            {checkColumn('priceDiscount', saleDetails) && isDiscount && isDiscount2 && isDiscount3 && isDiscount4 &&
                                <Text style={[styles.text10, { width: '55px', textAlign: 'center', borderRight: 0.5 }]}>{typeof (item.priceDiscount) == 'undefined' ?
                                    item.priceDiscount : helper().formatCurrency(item.priceDiscount, true)}</Text>
                            }
                            {checkColumn('vat', saleDetails) && settings.withVat === true && isExport && isVat &&
                                <Text style={[styles.text10, { width: '30px', textAlign: 'center', borderRight: 0.5 }]}>{item.vat}</Text>
                            }
                            {checkColumn('vatSum', saleDetails) && settings.withVat === true && isExport && isVat &&
                                <Text style={[styles.text10, { width: '45px', textAlign: 'center', borderRight: 0.5 }]}>{typeof (item.vatSum) == 'undefined' ?
                                    item.vatSum : helper().formatCurrency(item.vatSum, true)}</Text>
                            }
                            {checkColumn('totalPriceTvsh', saleDetails) &&
                                <Text style={[styles.text10, { width: '55px', textAlign: 'center' }]}>{typeof (item.totalPriceTvsh) == 'undefined' ?
                                    item.totalPriceTvsh : helper().formatCurrency(item.totalPriceTvsh, true)}</Text>
                            }
                        </View>
                    ))}
                </View>
                <View wrap={false} style={[styles.page, { marginTop: 5, paddingVertical: 5, alignItems: "flex-start" }]}>
                    <View style={[{ width: '65%', padding: 5 }]}>
                        <Text style={[styles.text10, { paddingRight: 10 }]}>{sale.comment ? sale.comment : ""}</Text>
                    </View>
                    <View style={[{ width: '35%', paddingVertical: 0, borderLeft: 1 }]}>
                        {isDiscount == true || isDiscount2 == true || isDiscount3 == true || isDiscount4 == true ?
                            <>
                                <View style={[styles.page, { borderTop: 1, marginTop: 0, paddingVertical: 0, paddingHorizontal: 5, alignItems: "flex-end", borderRight: 1 }]}>
                                    <View style={{ width: '50%', borderRight: 1 }}>
                                        <Text style={[styles.text10, { textAlign: 'left' }]}>{helper().translate("TOTAL_WITHOUT_DISCOUNT")}: </Text>
                                    </View>
                                    <View style={{ width: '50%' }}>
                                        <Text style={[styles.text10, { textAlign: 'right' }]}>{
                                            typeof ((sale.totalSum)) == 'undefined' ?
                                                (sale.totalSum) : helper().formatCurrency(calTotalWithoutDiscount)
                                        }</Text>
                                    </View>
                                </View>
                                <View style={[styles.page, { borderTop: 1, marginTop: 0, paddingVertical: 0, paddingHorizontal: 5, alignItems: "flex-end", borderRight: 1 }]}>
                                    <View style={{ width: '50%', borderRight: 1 }}>
                                        <Text style={[styles.text10, { textAlign: 'left' }]}>{helper().translate("DISCOUNT")}: </Text>
                                    </View>
                                    <View style={{ width: '50%' }}>
                                        <Text style={[styles.text10, { textAlign: 'right' }]}>{
                                            typeof ((sale.totalSum)) == 'undefined' ?
                                                (sale.totalSum) : helper().formatCurrency(parseFloat(calTotalWithoutDiscount - sale.totalSum))
                                        }</Text>
                                    </View>
                                </View>
                            </>
                            : null

                        }
                        <View style={[styles.page, { borderBottom: 1, borderTop: 1, marginTop: 0, paddingVertical: 0, paddingHorizontal: 5, alignItems: "flex-end", borderRight: 1 }]}>
                            <View style={{ width: '50%', borderRight: 1 }}>
                                <Text style={[styles.text10, { textAlign: 'left' }]}>{helper().translate("TOTAL")}: </Text>
                            </View>
                            <View style={{ width: '50%' }}>
                                <Text style={[styles.text10, { textAlign: 'right' }]}>{
                                    typeof ((sale.totalSum)) == 'undefined' ?
                                        (sale.totalSum) : helper().formatCurrency(sale.totalSum)
                                }</Text>
                            </View>
                        </View>
                        {
                            sale.withVat === true && vatGroup?.map((item) => (
                                <View style={[styles.page, { borderBottom: 1, marginTop: 0, paddingVertical: 0, paddingHorizontal: 5, alignItems: "flex-end", borderRight: 1 }]}>
                                    <View style={{ width: '50%', borderRight: 1 }}>
                                        <Text style={[styles.text10, { textAlign: 'left' }]}>{helper().translate("VAT_VALUE")} ({item.key}%): </Text>
                                    </View>
                                    <View style={{ width: '50%' }}>
                                        <Text style={[styles.text10, { textAlign: 'right' }]}>{helper().formatCurrency(parseFloat(item.value))}</Text>
                                    </View>
                                </View>
                            ))
                        }
                        {sale.withVat === true && <View style={[styles.page, { borderBottom: 1, marginTop: 0, paddingVertical: 0, paddingHorizontal: 5, alignItems: "flex-end", borderRight: 1 }]}>
                            <View style={{ width: '50%', borderRight: 1 }}>
                                <Text style={[styles.text10, { textAlign: 'left' }]}>{helper().translate("TOTAL_WITH_VAT")}: </Text>
                            </View>
                            {console.log('sale: ', sale)}
                            <View style={{ width: '50%' }}>
                                <Text style={[styles.text10, { textAlign: 'right' }]}>{typeof (sale.totalSum) == 'undefined' ?
                                    (sale.totalTvsh) : helper().formatCurrency(parseFloat(sale.totalTvsh))}</Text>
                            </View>
                        </View>}
                    </View>
                </View>
                {!digitalStamp && <View wrap={false} style={[styles.page, { width: '100%', marginTop: 80 }]}>
                    <View style={[{ textAlign: 'center', width: '50%' }]}>
                        <Text style={[styles.text10, { width: '60%', borderTop: 1, margin: 'auto' }]}>{helper().translate("SUBMITTED")}</Text>
                    </View>
                    <View style={[{ textAlign: 'center', width: '50%' }]}>
                        <Text style={[styles.text10, { width: '60%', borderTop: 1, margin: 'auto' }]}>{helper().translate("RECEIVED")}</Text>
                    </View>
                </View>}
                {digitalStamp && <View style={[styles.page, { width: '100%', marginTop: 60 }]}>
                    <View style={[{ textAlign: 'center', width: '50%' }]}>
                        <Image src={settings?.digitalStamp ? settings?.digitalStamp : config.noLogo} style={{ width: settings?.digitalStamp ? '100px' : '100px', marginHorizontal: 'auto', marginVertical: 0 }} />
                    </View>
                </View>}
                {digitalStamp && <Text style={[styles.pageNumbers, styles.italicFont, { textAlign: 'left' }]} fixed>{helper().translate("DIGITAL_STAMP_MESSAGE")}</Text>}
                <Text style={[styles.pageNumbers, styles.italicFont]} fixed>{helper().translate("IMPLEMENTED_BY")} T3 Next</Text>
            </Page>
        </Document>
    );
};

export default InvoiceDocument2;